import React from 'react';
import { Provider } from 'react-redux';
import LayoutPureSSR from './LayoutPureSSR';
import rootStore from '../store/createStoreSSR';
const LayoutSSR = ({ children, isLoggedSSR, footerData, isSticky, showExtoleReferFriend, registrationFlow }) => (React.createElement(Provider, { store: rootStore },
    React.createElement(LayoutPureSSR, { isLoggedSSR: isLoggedSSR, isSticky: isSticky, footerData: footerData, showExtoleReferFriend: showExtoleReferFriend, registrationFlow: registrationFlow }, children)));
export default LayoutSSR;
